import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { LoadingOverlay } from '@cbridge-tools/overlay';
import { useStreamDetailsLoader } from '@cbridge-packages/stream';
import { DetailsFormSidebarHeader, DetailsSidebarContent } from '@cbridge-modules/details-sidebar';
import { StreamDetailsToolbarActions } from '../actions/StreamDetailsToolbarActions';
import { StreamFormProvider } from '../formProvider/StreamFormProvider';
import { StreamSettingsSection } from './StreamSettingsSection/StreamSettingsSection';
import { StreamConnectedServersSection } from './StreamConnectedServersSection/StreamConnectedServersSection';
import { streamDetailsPropsSelector } from './StreamDetails.selector';

export const StreamDetails: FunctionComponent = () => {
  const { isCreateMode, streamId } = useSelector(streamDetailsPropsSelector);

  const { isLoading, isInitialized } = useStreamDetailsLoader(streamId);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (!isCreateMode && !isInitialized) {
    return null;
  }

  return (
    <StreamFormProvider key={`${String(isCreateMode)}_${streamId}`}>
      <DetailsFormSidebarHeader>
        <StreamDetailsToolbarActions />
      </DetailsFormSidebarHeader>
      <DetailsSidebarContent>
        <StreamSettingsSection />
        {!isCreateMode && <StreamConnectedServersSection streamId={streamId} />}
      </DetailsSidebarContent>
    </StreamFormProvider>
  );
};
